export default "__VITE_ASSET__DorEmIwL__"